/**
 * SIROY product card interactions:
 * 1) Hover secondary image and keep it
 * 2) Soft fade-up reveal on scroll (fallback if AOS class is slow/missing)
 */
(function () {
  function lockSecondaryImage(event) {
    var content = event.target.closest('.grid-product__content');
    if (!content) return;
    if (!content.querySelector('.grid-product__secondary-image')) return;
    content.classList.add('is-secondary-locked');
  }

  document.addEventListener('mouseenter', lockSecondaryImage, true);

  function preferReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealCards() {
    var cards = document.querySelectorAll('.siroy-featured-collection .grid-product');
    if (!cards.length) return;

    if (preferReducedMotion() || !('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealCards);
  } else {
    revealCards();
  }

  document.addEventListener('shopify:section:load', revealCards);

  /* Match left thumb column height to main product photo (laptop) */
  function syncPdpThumbHeight() {
    if (!window.matchMedia || !window.matchMedia('(min-width: 768px)').matches) {
      document.querySelectorAll('.siroy-pdp__gallery .product__thumbs--beside').forEach(function (el) {
        el.style.height = '';
        el.style.minHeight = '';
      });
      return;
    }

    document.querySelectorAll('.siroy-pdp__gallery').forEach(function (gallery) {
      var main = gallery.querySelector('.product__main-photos');
      var thumbs = gallery.querySelector('.product__thumbs--beside');
      if (!main || !thumbs) return;
      var h = Math.round(main.getBoundingClientRect().height);
      if (h > 0) {
        thumbs.style.height = h + 'px';
        thumbs.style.minHeight = h + 'px';
      }
    });
  }

  function bindPdpThumbSync() {
    syncPdpThumbHeight();
    window.addEventListener('resize', syncPdpThumbHeight);
    document.addEventListener('shopify:section:load', syncPdpThumbHeight);

    document.querySelectorAll('.siroy-pdp__gallery .product__main-photos img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', syncPdpThumbHeight);
    });

    // Theme slideshow can settle after init
    window.setTimeout(syncPdpThumbHeight, 300);
    window.setTimeout(syncPdpThumbHeight, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindPdpThumbSync);
  } else {
    bindPdpThumbSync();
  }

  /* HIM / HER collection dropdowns on Globo mega menu */
  var SIROY_NAV_DROPDOWNS = {
    HIM: [
      { label: 'T-shirts', href: '/collections/t-shirts' },
      { label: 'Jackets', href: '/collections/jackets' },
      { label: 'Pants & Shorts', href: '/collections/pants-shorts-1' },
      { label: 'Shirts', href: '/collections/shirts' },
    ],
    HER: [
      { label: 'Co-ord Sets', href: '/collections/co-ord-sets' },
      { label: 'Jackets', href: '/collections/jackets' },
      { label: 'Pants & Shorts', href: '/collections/pants-shorts' },
      { label: 'Shirts & Tops', href: '/collections/shirts-tops' },
    ],
  };

  function buildSiroyNavDropdown(items) {
    var ul = document.createElement('ul');
    ul.className = 'siroy-gm-dd';
    ul.setAttribute('role', 'list');
    items.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = item.href;
      a.textContent = item.label;
      li.appendChild(a);
      ul.appendChild(li);
    });
    return ul;
  }

  function enhanceSiroyHimHerNav() {
    Object.keys(SIROY_NAV_DROPDOWNS).forEach(function (title) {
      var links = document.querySelectorAll(
        '.gm-item.gm-level-0 > a.gm-target[title="' + title + '"]'
      );
      links.forEach(function (anchor) {
        var item = anchor.parentElement;
        if (!item || item.classList.contains('siroy-has-dd')) return;

        item.classList.add('siroy-has-dd', 'gm-has-submenu');
        if (!anchor.querySelector('.gm-retractor')) {
          var retractor = document.createElement('span');
          retractor.className = 'gm-retractor';
          anchor.appendChild(retractor);
        }
        item.appendChild(buildSiroyNavDropdown(SIROY_NAV_DROPDOWNS[title]));

        anchor.addEventListener('click', function (event) {
          if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) {
            return;
          }
          event.preventDefault();
          item.classList.toggle('is-open');
        });
      });
    });
  }

  function bindSiroyHimHerNav() {
    enhanceSiroyHimHerNav();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      enhanceSiroyHimHerNav();
      if (document.querySelector('.gm-item.siroy-has-dd') || tries > 40) {
        window.clearInterval(timer);
      }
    }, 250);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        enhanceSiroyHimHerNav();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () {
        observer.disconnect();
      }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSiroyHimHerNav);
  } else {
    bindSiroyHimHerNav();
  }
})();
